import * as React from 'react'
import TopNavigation from './TopNavigation'
import TopTestingNavigation from './TopTestingNavigation'
import {HeaderContainer} from './HeaderStyle'

export const Header = () => {
  return (
    <HeaderContainer>
      <TopTestingNavigation />
      <TopNavigation />
    </HeaderContainer>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/layout/Header.tsx